import React from 'react'

import Layout from '../layouts/zh'
import SEO from '../components/seo'
import BarChart from '../components/BarChart'
import PieChart from '../components/PieChart'
import GlobalIntershipTable from '../components/GlobalIntershipTable'

import Bubble from '../components/Bubble'
import IllustrationBox from '../components/IllustrationBox'
import Testimonial from '../components/Testimonial'
import FlickitySlider from '../components/FlickitySlider'
import MoreText from '../components/MoreText'
import VideoButton from '../components/VideoButton'

const TourismTeamMembers = require('../data/TourismTeamMembers')
const TourismCourseTeamMembers = require('../data/TourismCourseTeamMembers')

const IndexPage = (props) => (
  <Layout location={props.location}>
    <SEO title="旅遊高等學校" />

    <div
      className="bg-banner-30 bg-center bg-cover"
      style={{ backgroundImage: `url(/AnnualReport2017-2018/images/bg-tourism.jpg)`, minHeight: '200px' }}
      id="foster-future-talents"
    >
      <div className="absolute inset-0 py-12">
        <div className="container" data-aos="fade-up" data-aos-delay={400} data-aos-duration={1200}>
          <Bubble className="w-full md:w-1/2"
            title="培育明日之子的搖籃"
            subtitle=""
          >
          </Bubble>
        </div>
      </div>
    </div>

    <div className="py-8 md:py-12">
      <div className="container">
        <div className="flex flex-row flex-wrap">
          <div className="w-full lg:w-2/3" data-aos="fade-up">
            <div className="text-left mx-auto text-sm lg:text-base lg:pr-8 font-normal text-justify" data-aos="fade-up" data-aos-delay={600}>
              <p className="mb-4">旅遊學院旅遊高等學校為澳門社會發展提供重要的旅遊及服務範疇學士學位課程。旅遊高等學校課程結合理論和實踐，深受澳門旅遊及酒店業界乃至全球同業的廣泛認可。與此同時，學校與全球不同機構及組織建立夥伴關係，並積極加強交流合作，優化教學內容及建立優質師資隊伍，致力構建水平一流以及兼具國際化和前瞻性的高等教育體系。</p>
              <p className="mb-4">旅遊高等學校學生不僅可享受豐富多彩的校園生活，還可透過各種的校外活動，擴闊視野及獲得寶貴經驗，未雨綢繆做好未來的職業生涯規劃。學生可在學院的各式專業培訓設施中學以致用，包括教學餐廳、教學酒店、模擬前台及房務教室、中式及西式烹飪和示範廚房、文化遺產數碼檔案室，以及配備完善的教室。學院也為學生提供寶貴的社會實踐機會，包括籌辦各類型活動、參與公益慈善、編撰飲食指南及為本地企業提供商業諮詢服務等。</p>
              <p>旅遊學院具有高度的國際視野，並建立了龐大的國際網絡，遍佈全球各地的實習地點，包括比利時、中國內地、杜拜、馬來西亞、新加坡、西班牙、英國和美國等。學院鼓勵學生積極參加各種海外實習和交流計劃，以便於將所學的先進經驗融入未來職業實踐當中，有助於學生的全方位發展。</p>
            </div>
          </div>
          <div className="w-full lg:w-1/3 mt-8 lg:mt-0" data-aos="fade-up" data-aos-delay={800}>
            <Testimonial
              title="極致效能"
              color="orange"
            >
              <p>旅遊學院要求所有學士學位課程學生必須於第三學年完成為期六個月的實習課程，而理學士學位課程學生同時必須於四年級獨立完成研究論文。旅遊學院也是澳門唯一一家有此兩項要求的高等教育機構。</p>
            </Testimonial>
          </div>
        </div>
      </div>
    </div>

    <div className="bg-gray-200 py-8 md:py-12" id="our-bachelor-degree-programmes">
      <div className="container mb-12">
        <h2 className="text-3xl md:text-5xl text-orange-500 text-center mb-2" data-aos="fade-down">旅遊高等學校提供下列學士學位課程：</h2>
        <div className="flex flex-col flex-wrap">
          <div className="flex flex-row flex-wrap mt-12 w-full px-6 xl:px-0 xl:w-4/5 mx-auto">
            <div className="w-full md:w-1/2 md:pr-4" data-aos="fade-right" data-aos-delay={300}>
              <h4 className="text-xl md:text-2xl text-indigo-700 mb-2">日間學位課程：</h4>
              <ul className="list-disc">
                <li>
                  廚藝管理
                  <p className="pb-2">
                    <span className="text-orange-500">
                      【學生分享】盧栢愉
                    </span>
                    <span className="inline-block relative ml-4" style={{ top: '6px' }}>
                      <VideoButton url="https://player.youku.com/embed/XMjYxNzU2NTkxNg==" />
                    </span>
                  </p>
                </li>
                <li>
                  文化遺產管理
                  <p className="pb-2">
                    <span className="text-orange-500">
                      【校友分享】陳昭宇
                    </span>
                    <span className="inline-block relative ml-4" style={{ top: '6px' }}>
                      <VideoButton url="https://player.youku.com/embed/XMjYxNzYyNDI2NA==" />
                    </span>
                  </p>
                </li>
                <li>
                  酒店管理
                  <p className="pb-2">
                    <span className="text-orange-500">
                      【校友分享】朱震
                    </span>
                    <span className="inline-block relative ml-4" style={{ top: '6px' }}>
                      <VideoButton url="https://player.youku.com/embed/XMzcxNDU5NzA0OA==" />
                    </span>
                  </p>
                </li>
                <li>
                  旅遊企業管理
                  <p className="pb-2">
                    <span className="text-orange-500">
                      【校友分享】黃瑩珊
                    </span>
                    <span className="inline-block relative ml-4" style={{ top: '6px' }}>
                      <VideoButton url="https://player.youku.com/embed/XMzgxNDQ4MTc4OA==" />
                    </span>
                  </p>
                </li>
                <li>
                  旅遊會展及節目管理
                  <p className="pb-2">
                    <span className="text-orange-500">
                      【校友分享】Mandy Ho
                    </span>
                    <span className="inline-block relative ml-4" style={{ top: '6px' }}>
                      <VideoButton url="https://player.youku.com/embed/XNDE5MzM1MjA4MA==" />
                    </span>
                  </p>
                </li>
                <li>
                  旅遊零售及巿場推廣管理
                </li>
              </ul>
            </div>
            <div className="w-full md:w-1/2 md:pl-4 mt-8 md:mt-0" data-aos="fade-left" data-aos-delay={300}>
              <h4 className="text-xl md:text-2xl text-indigo-700 mb-2">夜間學位課程：</h4>
              <ul className="list-disc">
                <li>酒店管理</li>
                <li>旅遊會展及節目管理</li>
                <li>旅遊零售及市場推廣管理</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="py-8 md:py-12">
      <div className="container mb-12">
        <div className="flex flex-row flex-wrap mt-12 w-full lg:w-4/5 mx-auto">
          <div className="w-full md:w-1/2 md:pr-4" data-aos="zoom-in">
            <Testimonial
              title="旅遊服務業教育熱門選擇"
              color="blue"
            >
              旅遊學院優質的課程，成為澳門和海內外學生的心儀學府。與上一年相比，2017/18年度報名人數增長了27%。
            </Testimonial>
          </div>
          <div className="w-full md:w-1/2 md:pl-4 mt-12 md:mt-0" data-aos="zoom-in" data-aos-delay={300}>
            <IllustrationBox
              number={19}
              text="2017/18學年報讀旅遊學院課程的非澳門學生比例。學院非本地生主要來自中國內地，以及香港特別行政區、台灣地區、其他亞洲和歐美國家。"
              className="text-5xl"
              suffix="%"
              alignment="left"
            />

          </div>
        </div>
      </div>
    </div>

    <div className="bg-gray-200 py-8 md:py-12" id="students-enrolled-in-bachelors-degree-programmes">
      <div className="container mb-12">
        <h2 className="text-3xl md:text-5xl text-orange-500 text-center mb-2" data-aos="fade-down">學士學位課程入學人數</h2>
        <div className="flex flex-row flex-wrap">
          <div className="w-full md:w-4/5 md:mt-8 overflow-auto" data-aos="fade-up">
            <BarChart />
          </div>
          <div className="w-full md:w-1/5 mt-8" data-aos="fade-up" data-aos-delay={300}>
            <IllustrationBox
              number={29}
              title=""
              text="2017/18學年學士學位課程學生來自的國家及地區數目"
              className="text-5xl"
              alignment="left"
            />
          </div>
        </div>
      </div>
    </div>

    <div className="py-8 md:py-12" id="graduates-2017-18">
      <div className="container mb-12">
        <h2 className="text-3xl md:text-5xl text-orange-500 text-center mb-2" data-aos="fade-down">2017/18學年畢業生的課程分佈</h2>
        <div className="flex flex-row flex-wrap">
          <div className="w-full lg:w-4/5 lg:mt-8 overflow-auto" data-aos="fade-up">
            <PieChart />
          </div>
          <div className="w-full lg:w-1/5 mt-8" data-aos="fade-up" data-aos-delay={300}>
            <IllustrationBox
              number={277}
              title=""
              text="2017/18學年完成畢業論文的學生人數"
              className="text-5xl"
              alignment="left"
            />
          </div>
        </div>
      </div>
    </div>

    <div className="bg-gray-200 py-8 md:py-12" id="embrace-all-challenges">
      <div className="container mb-12">
        <h2 className="text-3xl md:text-5xl text-orange-500 text-center mb-2" data-aos="fade-down">迎接挑戰</h2>
        <div className="flex flex-col flex-wrap mt-8">
          <div className="w-full flex">
            <div className="text-left mx-auto text-sm md:text-base max-w-xl font-normal text-justify" data-aos="fade-down" data-aos-delay={150}>
              <p>在旅遊學院旅遊高等學校畢業的學生在職場上備受僱主讚賞。而我們的學士學位課程不僅是為學生就業，更是為他們在世界各地的頂尖大學繼續升學做好準備。</p>
            </div>
          </div>
        </div>

        <h4 className="text-2xl md:text-3xl text-blue-500 text-center mt-12 mb-12" data-aos="fade-up" data-aos-delay={300}>
          2018學年畢業生在畢業六個月後有甚麼去向？
          <br/>
          <p className="text-sm text-gray-500 mt-6 md:mt-2">
            資料來源：旅遊學院2018年12月“畢業生就業情況”問卷調查
          </p>
        </h4>

        <div className="flex flex-row flex-wrap">
          <div className="w-full md:w-1/5 mt-8" data-aos="fade-up" data-aos-delay={450}>
            <IllustrationBox
              number={70}
              title="調查成功訪問率"
              text="2017/18畢業生就業情況調查成功訪問率達70%"
              className="text-5xl"
              suffix="%"
              alignment="left"
            />
          </div>
          <div className="w-full md:w-1/5 mt-8" data-aos="fade-up" data-aos-delay={600}>
            <IllustrationBox
              number={85}
              title="畢業生成功就業"
              text="及繼續升學"
              className="text-5xl"
              suffix="%"
              alignment="left"
            />
          </div>
          <div className="w-full md:w-1/5 mt-16 md:mt-8 relative" data-aos="fade-up" data-aos-delay={750}>
            <p className="text-4xl text-blue-600 text-center absolute -mt-10 w-full">超過</p>
            <IllustrationBox
              number={70}
              title="投身"
              text="旅遊或服務業"
              className="text-5xl"
              suffix="%"
              alignment="left"
            />
          </div>
          <div className="w-full md:w-1/5 mt-8" data-aos="fade-up" data-aos-delay={900}>
            <IllustrationBox
              number={95}
              title="獲聘用的畢業生"
              text="的月薪超過澳門幣15,100元"
              className="text-5xl"
              suffix="%"
              alignment="left"
            />
          </div>
          <div className="w-full md:w-1/5 mt-8" data-aos="fade-up" data-aos-delay={1050}>
            <IllustrationBox
              number={82}
              title="畢業生推薦"
              text="學院學士課程"
              className="text-5xl"
              suffix="%"
              alignment="left"
            />
          </div>
        </div>
      </div>
    </div>

    <div className="py-8 md:py-12 md:pb-24" id="academic-staff">
      <div className="container">
        <h2 className="text-3xl md:text-5xl text-orange-500 text-center mb-2" data-aos="fade-down">教學人員</h2>
        <div className="w-full md:w-1/2 mx-auto my-12 text-center" data-aos="fade-up" data-aos-delay={150}>
          <h4 className="text-xl md:text-2xl text-indigo-700 mb-2">課程主任</h4>
          <div className="mx-auto max-w-xl text-left text-sm md:text-base font-normal text-justify">
            <p>優質的師資隊伍是教育機構培養傑出人才的保障。旅遊高等學校教師團隊匯聚世界各地人才，務實敬業，致力為旅遊各領域培育精英人才。</p>
          </div>
        </div>

        <FlickitySlider
          resizeListener={
            (resize) => {
              document.querySelectorAll('.more-text').forEach(item => {
                item.addEventListener('click', () => resize())
              })
            }
          }
        >
          {
            TourismTeamMembers.map((member, i) => (
              <div key={i} className={`w-full mb-12 text-center ${(i <= 1 ? 'md:w-1/2' : 'md:w-1/3')}`}>
                <div className="flex flex-col items-center mx-4">
                  <img src={`/AnnualReport2017-2018${member.image}`} alt="member" className="rounded-full w-40 h-40 mb-2" />

                  <div className="w-full text-2xl text-blue-500 leading-tight" dangerouslySetInnerHTML={{ __html: member.name['zh'] }}></div>
                  <div className="w-full mb-2 text-sm" dangerouslySetInnerHTML={{ __html: member.title['zh'] }}></div>
                  <MoreText className="w-full more-text text-sm font-normal text-left text-justify" limitTextLength={ member.textLength || 400 }>
                    { member.description['zh'] }
                  </MoreText>
                </div>
              </div>
            ))
          }
        </FlickitySlider>

        <div className="w-full md:w-1/2 mx-auto mt-20 mb-12 text-center" data-aos="fade-up">
          <h4 className="text-xl md:text-2xl text-indigo-700 mb-2">課程協調員和學科課程主任</h4>
          <div className="mx-auto max-w-xl text-left text-sm md:text-base font-normal text-justify">
            <p>學院課程協調員和學科課程主任的經驗豐富，負責各學科和實習計劃的內容設計及發展，並協調師資安排及監督教學質量，協助學生更好地學習知識和培養技能。</p>
          </div>
        </div>

        <FlickitySlider>
          {
            TourismCourseTeamMembers.map((member, i) => (
              <div key={i} className={`w-full mb-12 text-center md:w-1/4`}>
                <div className="flex flex-col items-center mx-4">
                  <img src={`/AnnualReport2017-2018${member.image}`} alt="member" className="rounded-full w-40 h-40 mb-2" />

                  <div className="w-full text-2xl text-blue-500 leading-tight" dangerouslySetInnerHTML={{ __html: member.name['zh'] }}></div>
                  <div className="w-full mb-2 text-sm" dangerouslySetInnerHTML={{ __html: member.title['zh'] }}></div>
                  <MoreText className="w-full more-text text-left text-sm font-normal text-justify" limitTextLength={ member.textLength || 400 }>
                    { member.description['zh'] }
                  </MoreText>
                </div>
              </div>
            ))
          }
        </FlickitySlider>
      </div>
    </div>

    <div className="bg-gray-200 py-8 md:py-12" id="student-research">
      <div className="container">
        <h2 className="text-3xl md:text-5xl text-orange-500 text-center mb-2" data-aos="fade-down">學生研究</h2>
        <div className="flex flex-row flex-wrap mt-8">
          <div className="w-full lg:w-1/3" data-aos="fade-right">
            <div className="inset-0">
              <img src="/AnnualReport2017-2018/images/tourism/6.3.1.jpg" alt="IFT" className="object-cover object-bottom h-full w-full shadow-xl rounded-sm" />
            </div>
            <div className="inset-0 mt-4">
              <img src="/AnnualReport2017-2018/images/tourism/6.3.2.jpg" alt="IFT" className="object-cover object-bottom h-full w-full shadow-xl rounded-sm" />
            </div>
          </div>
          <div className="w-full lg:w-2/3 flex" data-aos="fade-left">
            <div className="text-left mx-auto text-sm lg:text-base lg:pl-8 font-normal mt-4 lg:mt-0 text-justify">
              <p className="mb-4">旅遊學院要求所有日間理學學士學位課程學生必須獨立完成研究論文才可畢業，是全澳第一間有此強制性畢業要求的高等教育機構。</p>
              <p className="mb-4">自2015/16學年起，學院對所有日間理學學士學位課程學生新增一項畢業要求，他們每人必須獨立撰寫論文。此舉旨在培養學生獨立思考的能力，以及批判和分析思維。學生必須提出自己的研究方案及獨立撰寫論文，內容及研究成果必須為學生原創。在過程中，學生可獲內容導師的直接指導，以及英語寫作中心和研究輔助中心的持續支持。自學院在學士學位課程上新增完成研究論文作為畢業要求後，在國際上引起了廣泛關注，多名學生獲邀參加國際研討會等場合上發表其畢業研究論文。</p>
              <p>2017/18學年，兩名學院學生於2018年5月獲邀到奧地利IMC科技應用大學出席 “國際學生旅遊研究會議”（ISCONTOUR 2018）及一名學院學生獲邀出席英國牛津大學舉辦 “第七屆工業技術與管理學術會議”（ICITM 2018），並發表其研究論文，以及與出席學生、學者、研究人員和旅遊業人士進行知識交流和建立聯繫。</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="py-8 md:py-12">
      <div className="container">
        <div className="flex flex-row flex-wrap">
          <div className="w-full lg:w-1/2 mt-8 lg:mt-8 lg:pr-8 mb-8 lg:mb-0" data-aos="zoom-out">
            <Testimonial
              title="出類拔萃"
              color="blue"
            >
              <p>旅遊學院“旅遊教育學生峰會”於每一學年結束時舉行，旨在表揚準畢業生的優秀學士學位論文和研究成果。2018年首次以整日活動形式於學院外舉行的“旅遊教育學生峰會2018”，獲澳門麗景灣藝術酒店協辦。每屆峰會的論文集均在學院網站上發佈。</p>
            </Testimonial>
          </div>
          <div className="w-full lg:w-1/2 lg:mt-16 xl:mt-0" data-aos="flip-down">
            <div className="inset-0">
              <img src="/AnnualReport2017-2018/images/tourism/6.3.3.jpg" alt="IFT" className="object-cover object-bottom h-full w-full shadow-xl rounded-sm" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="bg-gray-200 py-8 md:py-12" id="global-internship">
      <div className="container">
        <h2 className="text-3xl md:text-5xl text-orange-500 text-center mb-2" data-aos="fade-down">非本地實習</h2>
        <div className="flex flex-col flex-wrap mt-8 mb-12">
          <div className="w-full flex">
            <div className="text-left mx-auto text-sm md:text-base max-w-xl font-normal text-justify" data-aos="fade-down" data-aos-delay={150}>
              <p>旅遊學院的畢業生在校儲備豐富的知識和實踐經驗。隨着學院的不斷發展，越來越多國際合作夥伴為學生提供實習機會。寶貴的機會將拓寬學生的視野，為未來踏入職場做好充足的準備。 </p>
            </div>
          </div>
        </div>

        <div data-aos="fade-up">
          <GlobalIntershipTable
            langKey={props.pageContext.langKey}
            className="mb-12"
          />
        </div>
      </div>
    </div>
  </Layout>
)

export default IndexPage
